import { cva } from 'class-variance-authority'

export const iconStyles = cva([
  'cursor-pointer',
  'hover:text-neutral-300',
  'transition-[background-color] duration-150 ease-in-out',
])

export const navListItemStyles = cva([
  'flex',
  'items-center',
  'justify-center',
  'h-[38px]',
  'w-9',
  'p-2',
  'rounded-[10px]',
  'border-none',
  'hover:bg-neutral-50',
  'cursor-pointer',
])
